import Vue from 'vue';
import VueRouter from 'vue-router';
import qs from 'qs';
import { routes } from './routes';

Vue.use(VueRouter);

export const router = new VueRouter({
	mode: 'hash',
	base: import.meta.env.BASE_URL,
	routes,
	stringifyQuery: (queryObject) => {
		const queryString = qs.stringify(queryObject, { encode: false, arrayFormat: 'brackets' });
		return queryString ? `?${queryString}` : ``;
	},
	parseQuery: qs.parse,
});
